<template>
  <div class="badge-container w-max">
    <div class="logo-container">
      <img src="https://publicassets.foreplay.co/foreplay-logo-dark.png" style="width: 36px; height: 36px;">
    </div>
    <div class="text-container">
      <svg xmlns="http://www.w3.org/2000/svg" width="61" height="15" viewBox="0 0 61 15" fill="none">
        <path d="M0 4.71667H1.48333V11.6667H3.3V4.71667H5.58333V3.13333H3.26667V2.41667C3.26667 1.83333 3.51667 1.58333 4.1 1.58333H5.58333V0H3.86667C2.21667 0 1.48333 0.800001 1.48333 2.33333V3.13333H0V4.71667Z" fill="#06070F"/>
        <path d="M10.1897 11.7667C12.7897 11.7667 14.5397 10.0167 14.5397 7.4C14.5397 4.8 12.7897 3.03333 10.1897 3.03333C7.58971 3.03333 5.83971 4.8 5.83971 7.4C5.83971 10.0167 7.58971 11.7667 10.1897 11.7667ZM10.1897 10.2333C8.67305 10.2333 7.68971 9.05 7.68971 7.4C7.68971 5.75 8.67305 4.56667 10.1897 4.56667C11.7064 4.56667 12.7064 5.75 12.7064 7.4C12.7064 9.05 11.7064 10.2333 10.1897 10.2333Z" fill="#06070F"/>
        <path d="M20.3038 3.13333C18.9038 3.13333 18.2204 3.7 17.7871 4.41667L17.5871 3.13333H15.9871V11.6667H17.7871V7.38333C17.7871 6.06667 18.3038 4.81667 19.9038 4.81667H20.7038V3.13333H20.3038Z" fill="#06070F"/>
        <path d="M25.457 11.7667C27.5737 11.7667 29.007 10.4833 29.307 8.8H27.507C27.257 9.75 26.457 10.3 25.357 10.3C23.9404 10.3 23.0237 9.35 22.9737 7.9V7.78333H29.407C29.4404 7.55 29.457 7.31667 29.457 7.1C29.407 4.6 27.757 3.03333 25.2904 3.03333C22.7737 3.03333 21.0904 4.78333 21.0904 7.41667C21.0904 10.0333 22.7737 11.7667 25.457 11.7667ZM23.0404 6.46667C23.1737 5.25 24.157 4.48333 25.307 4.48333C26.557 4.48333 27.4404 5.2 27.5904 6.46667H23.0404Z" fill="#06070F"/>
        <path d="M35.4789 3.03333C34.1456 3.03333 33.2622 3.65 32.6956 4.4L32.4789 3.13333H30.9122V15H32.7122V10.4667C33.2456 11.2333 34.1622 11.7667 35.4789 11.7667C37.8122 11.7667 39.5122 10.0333 39.5122 7.4C39.5122 4.66667 37.8122 3.03333 35.4789 3.03333ZM35.1789 10.25C33.6789 10.25 32.6956 9.06667 32.6956 7.36667C32.6956 5.71667 33.6789 4.56667 35.1789 4.56667C36.6789 4.56667 37.6789 5.71667 37.6789 7.4C37.6789 9.06667 36.6789 10.25 35.1789 10.25Z" fill="#06070F"/>
        <path d="M40.9546 11.6667H42.7546V0H40.9546V11.6667Z" fill="#06070F"/>
        <path d="M52.319 10.1C51.9523 10.1 51.769 9.98333 51.769 9.55V6.13333C51.769 4.11667 50.469 3.03333 48.2023 3.03333C46.0523 3.03333 44.619 4.06667 44.4357 5.73333H46.2023C46.3357 4.98333 47.0523 4.48333 48.119 4.48333C49.3023 4.48333 49.9857 5.06667 49.9857 6.01667V6.53333H47.8357C45.4523 6.53333 44.1857 7.51667 44.1857 9.26667C44.1857 10.85 45.4857 11.7667 47.3523 11.7667C48.7357 11.7667 49.6023 11.1667 50.169 10.3C50.169 11.15 50.569 11.6667 51.7357 11.6667H52.6857V10.1H52.319ZM49.9857 8.16667C49.969 9.48333 49.1023 10.3667 47.6023 10.3667C46.619 10.3667 46.019 9.86667 46.019 9.15C46.019 8.28333 46.6357 7.86667 47.7523 7.86667H49.9857V8.16667Z" fill="#06070F"/>
        <path d="M55.7747 11.7167L55.4414 12.55C55.1747 13.25 55.0081 13.4167 54.3081 13.4167H53.0414V15H54.9747C56.2247 15 56.5914 14.3833 57.1247 13L60.9914 3.13333H59.0747L56.7581 9.61667L54.3747 3.13333H52.4581L55.7747 11.7167Z" fill="#06070F"/>
      </svg>
      <div class="flex items-center gap-1 mt-px">
        <VerifiedBadgeIcon />
        <BaseText type="body" size="xs" class="text-neutral-900 pr-0.5" style="font-weight: 500;">
          Verified Agency
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import VerifiedBadgeIcon from '../../../globals/Icons/AgencyIcons/VerifiedBadgeIcon.vue'

export default {
  name: 'ForeplayAgencyBadgeLight',
  components: {
    VerifiedBadgeIcon
  }
}
</script>

<style scoped>
.badge-container {
  display: flex;
  align-items: center;
  gap: 9px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 3px;
  padding-right: 8px;
  border-radius: 12px;
  background-color: white;
}
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  border-radius: 9px;
  background: linear-gradient(180deg, #EBEFF3 0%, transparent 100%);
}
.text-container {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-right: 5px;
}
</style>